<div class="info-bar" *ngIf="infoBarData">
    <div class="content-box" [ngClass]="{'schedule-open': schedule.open, 'has-location': location}" >
        <div class="location-section section" *ngIf="location">
           <a *ngIf="location.link"
                finderAriaLabelHtml
                [href]="location.link"
                target="_self"
                finderLocale
                finderLinkId
            >
                <ng-container
                    [ngTemplateOutlet]="iconAndLabel"
                    [ngTemplateOutletContext]="{ $implicit: location }">
                </ng-container>
            </a>
            <span *ngIf="!location.link">
                <ng-container
                    [ngTemplateOutlet]="iconAndLabel"
                    [ngTemplateOutletContext]="{ $implicit: location }">
                </ng-container>
            </span>
        </div>
        <div class="schedule-section section" *ngIf="schedule">
            <a finderAriaLabelHtml href="/calendars/"
                finderLocale
                finderLinkId
                (click)="show($event)"
                (keydown.tab)="focusScheduleInfoElement()"
                #scheduleSection
            >
                <ng-container
                    [ngTemplateOutlet]="iconAndLabel"
                    [ngTemplateOutletContext]="{ $implicit: schedule }">
                </ng-container>
            </a>
        </div>
        <div class="map-section section" *ngIf="map"
            (click)="scroll($event)"
            tabindex="-1"
        >
            <a finderAriaLabelHtml href="" finderLinkId>
                <ng-container
                    [ngTemplateOutlet]="iconAndLabel"
                    [ngTemplateOutletContext]="{ $implicit: map }">
                </ng-container>
            </a>
        </div>
        <div class="button button-section" *ngIf="button">
            <finder-button
                [href]="button.link"
                class="action-btn"
                theme="primary"
                [target]="button.target"
            >{{button.label}}</finder-button>
        </div>
        <div class="schedule-container" [ngClass]="{'open': schedule.open}">
            <finder-schedule-info
                [scheduleData]="schedule"
                [locationData]="location"
                [scheduleOpen]="schedule.open"
                (keyup.esc)="closeScheduleInfo()"
                tabindex="0"
                #scheduleInfo
            ></finder-schedule-info>
        </div>
    </div>
</div>

<ng-template #iconAndLabel let-item>
    <span class="icon-section">
        <finder-font-icon
            [htmlEntity]="item.icon"
            size="m"
            [title]="item.label"
        ></finder-font-icon>
    </span>
    <span class="label-section">{{item.label}}</span>
</ng-template>
